import validator from 'validator';

// Validators should be generic enough to support string|number|boolean
export default class KInputValidate {
	static minLength = (length: number, errorMessage?: string) => {
		return (value: string | number | boolean): string | boolean => value.toString().trim().length >= length || errorMessage || KInputValidate.errorMessage.minLength.replace('%s', length.toString());
	};
	static maxLength = (length: number, errorMessage?: string) => {
		return (value: string | number | boolean): string | boolean => value.toString().trim().length <= length || errorMessage || KInputValidate.errorMessage.maxLength.replace('%s', length.toString());
	};
	static required = (errorMessage?: string) => {
		return (value: string | number | boolean): string | boolean =>
			value === true || (!!value && value.toString().trim().length !== 0) || value === 0 || errorMessage || KInputValidate.errorMessage.required;
	};
	static regex = (regex: RegExp, errorMessage?: string) => {
		return (value: string | number | boolean): string | boolean => validator.matches(value.toString(), regex) || errorMessage || KInputValidate.errorMessage.regex;
	};

	// Full list - https://www.npmjs.com/package/validator#user-content-validators
	static isAlpha = (errorMessage?: string) => {
		return (value: string | number | boolean): string | boolean => validator.isAlpha(value.toString()) || errorMessage || KInputValidate.errorMessage.alpha;
	};
	static isAlphanumeric = (errorMessage?: string) => {
		return (value: string | number | boolean): string | boolean => validator.isAlphanumeric(value.toString()) || errorMessage || KInputValidate.errorMessage.alphanumeric;
	};
	static isEmail = (errorMessage?: string) => {
		return (value: string | number | boolean): string | boolean => validator.isEmail(value.toString()) || errorMessage || KInputValidate.errorMessage.email;
	};
	static isFqdn = (errorMessage?: string) => {
		return (value: string | number | boolean): string | boolean  => validator.isFQDN(value.toString()) || errorMessage || KInputValidate.errorMessage.fqdn;
	};
	static isNumeric = (errorMessage?: string) => {
		return (value: string | number | boolean): string | boolean => {
			return validator.isNumeric(value.toString()) || errorMessage || KInputValidate.errorMessage.numeric;
		};
	};
	static isUnique = (haystack: string[], errorMessage?: string) => {
		return (value: string | number | boolean): string | boolean => {
			return !validator.isIn(value.toString(), haystack) || errorMessage || KInputValidate.errorMessage.unique.replace('%s', value.toString());
		};
	};

	// options = { protocols: ['http','https','ftp'], require_tld: true, require_protocol: false, require_host: true, require_valid_protocol: true, allow_underscores: false, 
	//             host_whitelist: false, host_blacklist: false, allow_trailing_dot: false, allow_protocol_relative_urls: false, disallow_auth: false }
	static isUrl = (options: Record<string, boolean | string[]>, errorMessage?: string): (value: string | number | boolean) => boolean | string => {
		return (value: string | number | boolean) => validator.isURL(value.toString(), options) || errorMessage || KInputValidate.errorMessage.url;
	};

	static errorMessage: Record<string, string> = {
		alpha: 'Only letters are allowed.',
		alphanumeric: 'Only numbers or letters without spaces are allowed.',
		email: 'Please provide a valid e-mail address.',
		fqdn: 'Please provide a valid domain, ex: domain.com.',
		numeric: 'Only numbers are allowed.',
		minLength: 'Must have a minimum length of %s.',
		maxLength: 'Must have a maximum length of %s.',
		regex: 'Please complete this field.',
		required: 'Please complete this field.',
		unique: 'This %s already exists.',
		url: 'Please provide a properly formatted URL.',
	};
}